/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_BeforeInputs */

const en_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

const fr_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant`)
};

const de_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor`)
};

const it_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima`)
};

const ru_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До`)
};

const es_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

const zh_cn2_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前`)
};

const ja_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前に`)
};

const hi_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले`)
};

const pt_pt2_merge_swal_before = /** @type {(inputs: Merge_Swal_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

/**
* | output |
* | --- |
* | "Before" |
*
* @param {Merge_Swal_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_before = /** @type {((inputs?: Merge_Swal_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_before(inputs)
	if (locale === "de") return de_merge_swal_before(inputs)
	if (locale === "it") return it_merge_swal_before(inputs)
	if (locale === "ru") return ru_merge_swal_before(inputs)
	if (locale === "es") return es_merge_swal_before(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_before(inputs)
	if (locale === "ja") return ja_merge_swal_before(inputs)
	if (locale === "hi") return hi_merge_swal_before(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_before(inputs)
	return en_merge_swal_before(inputs)
});